import PasswordDefinitionExperience from "../components/PasswordDefinitionExperience";

export default function AuthCallbackPage() {
  return <PasswordDefinitionExperience mode="invitation" />;
}